export default "__VITE_ASSET__B$QeLDuj__"